import React from "react";

function NotFound() {
  return <div>404</div>;
}

export default NotFound;
